var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        "data-layout-folder-browser-modal": "",
        size: "xl",
        centered: "",
        scrollable: "",
        title: "Folders",
        "ok-title": "Accept",
        "cancel-variant": "outline-primary",
        "ok-disabled": _vm.isConfirmDisabled,
      },
      on: { ok: _vm.confirm, hidden: _vm.handleModalClose },
      model: {
        value: _vm.isModalOpened,
        callback: function ($$v) {
          _vm.isModalOpened = $$v
        },
        expression: "isModalOpened",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex actions pl-2 justify-content-between align-items-center",
        },
        [
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "div",
              {
                staticClass: "action-btn",
                class: { active: _vm.type === "Move" },
                on: {
                  click: function ($event) {
                    return _vm.setType("Move")
                  },
                },
              },
              [_c("span", [_vm._v("Move to folder")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "action-btn",
                class: { active: _vm.type === "Copy" },
                on: {
                  click: function ($event) {
                    return _vm.setType("Copy")
                  },
                },
              },
              [_c("span", [_vm._v("Copy to folder")])]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-auto d-flex align-items-center" }, [
            _vm.hasActiveSearch
              ? _c(
                  "a",
                  {
                    staticClass: "clear-search-btn mr-3",
                    attrs: { href: "#" },
                    on: { click: _vm.clearSearch },
                  },
                  [
                    _c("i", { staticClass: "bi bi-x-circle mr-1" }),
                    _vm._v("\n        Clear search\n      "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.lastUsedFolder
              ? _c(
                  "a",
                  {
                    staticClass: "use-last-folder-btn",
                    attrs: { href: "#" },
                    on: { click: _vm.useLastFolder },
                  },
                  [
                    _vm._v(
                      "\n        Use last folder (" +
                        _vm._s(_vm.lastUsedFolder.name) +
                        ")\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("layout-folder-browser", { attrs: { "is-modal-instance": true } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }